import {
    CONCERN_LEVELS, CONDITIONAL_BOOLEAN, FOCUS_AREAS 
} from '../../../config/types';

import theme, {
    TypographyWeights 
} from '../../../../../figmaTheme';
import {
    EFFECT_FREQUENCIES 
} from '../../../config/types';
import CostBaseline from '../../../screens/animations/costBaseline';
import DrinkBaselineIntro from '../../../screens/animations/drinkBaselineIntro';
import DrinkBaselineOutro from '../../../screens/animations/drinkBaselineOutro';
import HabitsSection from '../../../screens/animations/habitsSection';
import SectionIntro from '../../../screens/animations/sectionIntro';
import DrinkBaselines from '../../../screens/drinkBaselines';
import DrinkCost from '../../../screens/drinkCost';
import MultipleChoiceScreen from '../../../screens/multipleChoice';
import NameInputScreen from '../../../screens/nameInput';
import DrinkTargets from '../../../screens/drinkTargets';
import CircleTakeover from '../../../screens/animations/circleTakeover';
import MultiSelectScreen from '../../../screens/multiSelect';
import DrinkJourney from '../../../screens/animations/drinkJourney';
import HabitsQuote from '../../../screens/animations/habitsQuote';
import EmailInputScreen from '../../../screens/emailInput';
import DrinkBaselines2 from '../../../screens/drinkBaselines2';

export const HABITS_SCREENS = [
    {
        key: 'habits section',
        trackingName: 'habits section',
        screenName: 'habits section',
        component: <HabitsSection />
    },
    {
        key: 'habits section intro',
        screenName: 'habits section intro',
        component: (
            <SectionIntro
                sectionKey={'habits'}
                subtitle={'Now that you\'ve shared your goals, let\'s explore your current habits, which we\'ll use to personalize your Sunnyside plan.'}
            />
        )
    },
    {
        key: 'name input',
        trackingName: 'your_name',
        screenName: 'name input',
        component: (
            <NameInputScreen
                key={'name input'}
                position={1}
                sectionKey={'habits'}
                backJump={2}
            />
        )
    },
    {
        key: 'drink baselines intro',
        screenName: 'drink baselines intro',
        component: (
            <DrinkBaselineIntro
                position={2}
            />
        )
    },
    {
        key: 'drink baselines',
        screenName: 'drink baselines',
        component: (
            <DrinkBaselines
                position={4}
            />
        )
    },
    {
        key: 'drink baselines summary',
        trackingName: 'baselines',
        screenName: 'drink baselines summary',
        component: (
            <DrinkBaselineOutro
                position={12}
            />
        )
    },
    {
        key: 'drink cost',
        trackingName: 'drink cost',
        screenName: 'drink cost',
        component: (
            <DrinkCost
                position={13}
            />
        )
    },
    {
        key: 'cost baseline',
        trackingName: 'cost baseline',
        screenName: 'cost baseline',
        component: (
            <CostBaseline
                position={14}
            />
        )
    },
    {
        key: 'freq of effects',
        trackingName: 'freq_of_effects',
        screenName: 'freq of effects',
        component: (
            <MultipleChoiceScreen
                position={15}
                sectionKey={'habits'}
                answerKey={'freq_of_effects'}
                title={`How often do you wake up feeling the <span style="font-weight:${TypographyWeights.BOLD};color:${theme.palette.secondary.main};">negative effects</span> of alcohol?`}
                subtitle={'Headache, stomach issues, brain fog, low energy, etc.'}
                choices={EFFECT_FREQUENCIES}
            />
        )
    },
    {
        key: 'concern level',
        trackingName: 'concern_level',
        screenName: 'concern level',
        component: (
            <MultipleChoiceScreen
                position={16}
                sectionKey={'habits'}
                answerKey={'concern_level'}
                title={'Do you ever get concerned about the amount you drink?'}
                choices={CONCERN_LEVELS}
            />
        )
    },
    {
        key: 'custom target selection',
        trackingName: 'custom target selection',
        screenName: 'custom target selection',
        component: (
            <MultipleChoiceScreen
                position={17}
                sectionKey={'habits'}
                answerKey={'customTargets'}
                title={`You mentioned drinking less was your desired outcome. Do you have a <span style="color:${theme.palette.secondary.main};font-weight:${TypographyWeights.BOLD};">specific weekly drink target</span> in mind?`}
                choices={CONDITIONAL_BOOLEAN}
            />
        )
    },
    {
        key: 'drink target inputs',
        screenName: 'drink target inputs',
        component: (
            <DrinkTargets
                position={18}
                forwardJump={2}
            />
        )
    },
    {
        key: 'custom target skip',
        trackingName: 'custom target skip',
        screenName: 'custom target skip',
        component: (
            <CircleTakeover
                position={18}
                sectionKey={'habits'}
                title={'No problem, you\'re in good hands!'}
                body={'We\'ll set your initial taper targets based on current health guidelines. And don\'t worry, you can always adjust them later.'}
                backJump={2}
            />
        )
    },
    {
        key: 'focus areas',
        trackingName: 'focus_areas',
        screenName: 'focus areas',
        component: (
            <MultiSelectScreen
                position={19}
                sectionKey={'habits'}
                answerKey={'focus_areas'}
                title={'What areas of your drinking can we help you improve?'}
                subtitle={'Choose as many as you\'d like:'}
                choices={FOCUS_AREAS}
            />
        )
    },
    {
        key: 'drink journey',
        trackingName: 'drink journey',
        screenName: 'drink journey',
        component: (
            <DrinkJourney
                position={20}
            />
        )
    },
    {
        key: 'habits section quote',
        trackingName: 'habits section quote',
        screenName: 'habits section quote',
        component: <HabitsQuote />
    }
];

export const HABITS_SCREENS_V2 = [
    {
        key: 'habits section',
        trackingName: 'habits section',
        screenName: 'habits section',
        component: <HabitsSection />
    },
    {
        key: 'habits section intro',
        screenName: 'habits section intro',
        component: (
            <SectionIntro
                sectionKey={'habits'}
                subtitle={'Now that you\'ve shared your goals, let\'s explore your current habits, which we\'ll use to personalize your Sunnyside plan.'}
            />
        )
    },
    {
        key: 'email entry',
        trackingName: 'email entry',
        screenName: 'email entry',
        component: (
            <EmailInputScreen
                position={1}
                sectionKey={'habits'}
                backJump={2}
            />
        )
    },
    {
        key: 'drink baselines intro',
        screenName: 'drink baselines intro',
        component: (
            <DrinkBaselineIntro
                position={2}
            />
        )
    },
    {
        key: 'drink baselines',
        screenName: 'drink baselines',
        component: (
            <DrinkBaselines
                position={4}
            />
        )
    },
    {
        key: 'drink baselines summary',
        trackingName: 'baselines',
        screenName: 'drink baselines summary',
        component: (
            <DrinkBaselineOutro
                position={12}
            />
        )
    },
    {
        key: 'drink cost',
        trackingName: 'drink cost',
        screenName: 'drink cost',
        component: (
            <DrinkCost
                position={13}
            />
        )
    },
    {
        key: 'cost baseline',
        trackingName: 'cost baseline',
        screenName: 'cost baseline',
        component: (
            <CostBaseline
                position={14}
            />
        )
    },
    {
        key: 'freq of effects',
        trackingName: 'freq_of_effects',
        screenName: 'freq of effects',
        component: (
            <MultipleChoiceScreen
                position={15}
                sectionKey={'habits'}
                answerKey={'freq_of_effects'}
                title={`How often do you wake up feeling the <span style="font-weight:${TypographyWeights.BOLD};color:${theme.palette.secondary.main};">negative effects</span> of alcohol?`}
                subtitle={'Headache, stomach issues, brain fog, low energy, etc.'}
                choices={EFFECT_FREQUENCIES}
            />
        )
    },
    {
        key: 'concern level',
        trackingName: 'concern_level',
        screenName: 'concern level',
        component: (
            <MultipleChoiceScreen
                position={16}
                sectionKey={'habits'}
                answerKey={'concern_level'}
                title={'Do you ever get concerned about the amount you drink?'}
                choices={CONCERN_LEVELS}
            />
        )
    },
    {
        key: 'custom target selection',
        trackingName: 'custom target selection',
        screenName: 'custom target selection',
        component: (
            <MultipleChoiceScreen
                position={17}
                sectionKey={'habits'}
                answerKey={'customTargets'}
                title={`You mentioned drinking less was your desired outcome. Do you have a <span style="color:${theme.palette.secondary.main};font-weight:${TypographyWeights.BOLD};">specific weekly drink target</span> in mind?`}
                choices={CONDITIONAL_BOOLEAN}
            />
        )
    },
    {
        key: 'drink target inputs',
        screenName: 'drink target inputs',
        component: (
            <DrinkTargets
                position={18}
                forwardJump={2}
            />
        )
    },
    {
        key: 'custom target skip',
        trackingName: 'custom target skip',
        screenName: 'custom target skip',
        component: (
            <CircleTakeover
                position={18}
                sectionKey={'habits'}
                title={'No problem, you\'re in good hands!'}
                body={'We\'ll set your initial taper targets based on current health guidelines. And don\'t worry, you can always adjust them later.'}
                backJump={2}
            />
        )
    },
    {
        key: 'focus areas',
        trackingName: 'focus_areas',
        screenName: 'focus areas',
        component: (
            <MultiSelectScreen
                position={19}
                sectionKey={'habits'}
                answerKey={'focus_areas'}
                title={'What areas of your drinking can we help you improve?'}
                subtitle={'Choose as many as you\'d like:'}
                choices={FOCUS_AREAS}
            />
        )
    },
    {
        key: 'drink journey',
        trackingName: 'drink journey',
        screenName: 'drink journey',
        component: (
            <DrinkJourney
                position={20}
            />
        )
    },
    {
        key: 'habits section quote',
        trackingName: 'habits section quote',
        screenName: 'habits section quote',
        component: <HabitsQuote />
    }
];

export const HABITS_SCREENS_V3 = [
    {
        key: 'habits section',
        trackingName: 'habits section',
        screenName: 'habits section',
        component: <HabitsSection />
    },
    {
        key: 'habits section intro',
        screenName: 'habits section intro',
        component: (
            <SectionIntro
                sectionKey={'habits'}
                subtitle={'Now that you\'ve shared your goals, let\'s explore your current habits, which we\'ll use to personalize your Sunnyside plan.'}
            />
        )
    },
    {
        key: 'email entry',
        trackingName: 'email entry',
        screenName: 'email entry',
        component: (
            <EmailInputScreen
                position={1}
                sectionKey={'habits'}
                backJump={2}
            />
        )
    },
    {
        key: 'drink baselines intro',
        screenName: 'drink baselines intro',
        component: (
            <DrinkBaselineIntro
                position={2}
            />
        )
    },
    {
        key: 'drink baselines',
        screenName: 'drink baselines',
        component: (
            <DrinkBaselines2
                position={4}
            />
        )
    },
    {
        key: 'drink cost',
        trackingName: 'drink cost',
        screenName: 'drink cost',
        component: (
            <DrinkCost
                position={12}
            />
        )
    },
    {
        key: 'cost baseline',
        trackingName: 'cost baseline',
        screenName: 'cost baseline',
        component: (
            <CostBaseline
                position={13}
            />
        )
    },
    {
        key: 'freq of effects',
        trackingName: 'freq_of_effects',
        screenName: 'freq of effects',
        component: (
            <MultipleChoiceScreen
                position={14}
                sectionKey={'habits'}
                answerKey={'freq_of_effects'}
                title={`How often do you wake up feeling the <span style="font-weight:${TypographyWeights.BOLD};color:${theme.palette.secondary.main};">negative effects</span> of alcohol?`}
                subtitle={'Headache, stomach issues, brain fog, low energy, etc.'}
                choices={EFFECT_FREQUENCIES}
            />
        )
    },
    {
        key: 'concern level',
        trackingName: 'concern_level',
        screenName: 'concern level',
        component: (
            <MultipleChoiceScreen
                position={15}
                sectionKey={'habits'}
                answerKey={'concern_level'}
                title={'Do you ever get concerned about the amount you drink?'}
                choices={CONCERN_LEVELS}
            />
        )
    },
    {
        key: 'custom target selection',
        trackingName: 'custom target selection',
        screenName: 'custom target selection',
        component: (
            <MultipleChoiceScreen
                position={16}
                sectionKey={'habits'}
                answerKey={'customTargets'}
                title={`You mentioned drinking less was your desired outcome. Do you have a <span style="color:${theme.palette.secondary.main};font-weight:${TypographyWeights.BOLD};">specific weekly drink target</span> in mind?`}
                choices={CONDITIONAL_BOOLEAN}
            />
        )
    },
    {
        key: 'drink target inputs',
        screenName: 'drink target inputs',
        component: (
            <DrinkTargets
                position={17}
                forwardJump={2}
            />
        )
    },
    {
        key: 'custom target skip',
        trackingName: 'custom target skip',
        screenName: 'custom target skip',
        component: (
            <CircleTakeover
                position={17}
                sectionKey={'habits'}
                title={'No problem, you\'re in good hands!'}
                body={'We\'ll set your initial taper targets based on current health guidelines. And don\'t worry, you can always adjust them later.'}
                backJump={2}
            />
        )
    },
    {
        key: 'focus areas',
        trackingName: 'focus_areas',
        screenName: 'focus areas',
        component: (
            <MultiSelectScreen
                position={18}
                sectionKey={'habits'}
                answerKey={'focus_areas'}
                title={'What areas of your drinking can we help you improve?'}
                subtitle={'Choose as many as you\'d like:'}
                choices={FOCUS_AREAS}
            />
        )
    },
    {
        key: 'drink journey',
        trackingName: 'drink journey',
        screenName: 'drink journey',
        component: (
            <DrinkJourney
                position={19}
            />
        )
    },
    {
        key: 'habits section quote',
        trackingName: 'habits section quote',
        screenName: 'habits section quote',
        component: <HabitsQuote />
    }
];

export const HABITS_SCREENS_V4 = [
    {
        key: 'habits section',
        trackingName: 'habits section',
        screenName: 'habits section',
        component: <HabitsSection />
    },
    {
        key: 'habits section intro',
        screenName: 'habits section intro',
        component: (
            <SectionIntro
                sectionKey={'habits'}
                subtitle={'Now that you\'ve shared your goals, let\'s explore your current habits, which we\'ll use to personalize your Sunnyside plan.'}
            />
        )
    },
    {
        key: 'drink baselines intro',
        screenName: 'drink baselines intro',
        component: (
            <DrinkBaselineIntro
                position={1}
                backJump={2}
            />
        )
    },
    {
        key: 'drink baselines',
        screenName: 'drink baselines',
        component: (
            <DrinkBaselines2
                position={3}
            />
        )
    },
    {
        key: 'drink cost',
        trackingName: 'drink cost',
        screenName: 'drink cost',
        component: (
            <DrinkCost
                position={11}
            />
        )
    },
    {
        key: 'cost baseline',
        trackingName: 'cost baseline',
        screenName: 'cost baseline',
        component: (
            <CostBaseline
                position={12}
            />
        )
    },
    {
        key: 'freq of effects',
        trackingName: 'freq_of_effects',
        screenName: 'freq of effects',
        component: (
            <MultipleChoiceScreen
                position={13}
                sectionKey={'habits'}
                answerKey={'freq_of_effects'}
                title={`How often do you wake up feeling the <span style="font-weight:${TypographyWeights.BOLD};color:${theme.palette.secondary.main};">negative effects</span> of alcohol?`}
                subtitle={'Headache, stomach issues, brain fog, low energy, etc.'}
                choices={EFFECT_FREQUENCIES}
            />
        )
    },
    {
        key: 'concern level',
        trackingName: 'concern_level',
        screenName: 'concern level',
        component: (
            <MultipleChoiceScreen
                position={14}
                sectionKey={'habits'}
                answerKey={'concern_level'}
                title={'Do you ever get concerned about the amount you drink?'}
                choices={CONCERN_LEVELS}
            />
        )
    },
    {
        key: 'custom target selection',
        trackingName: 'custom target selection',
        screenName: 'custom target selection',
        component: (
            <MultipleChoiceScreen
                position={15}
                sectionKey={'habits'}
                answerKey={'customTargets'}
                title={`You mentioned drinking less was your desired outcome. Do you have a <span style="color:${theme.palette.secondary.main};font-weight:${TypographyWeights.BOLD};">specific weekly drink target</span> in mind?`}
                choices={CONDITIONAL_BOOLEAN}
            />
        )
    },
    {
        key: 'drink target inputs',
        screenName: 'drink target inputs',
        component: (
            <DrinkTargets
                position={16}
                forwardJump={2}
            />
        )
    },
    {
        key: 'custom target skip',
        trackingName: 'custom target skip',
        screenName: 'custom target skip',
        component: (
            <CircleTakeover
                position={16}
                sectionKey={'habits'}
                title={'No problem, you\'re in good hands!'}
                body={'We\'ll set your initial taper targets based on current health guidelines. And don\'t worry, you can always adjust them later.'}
                backJump={2}
            />
        )
    },
    {
        key: 'focus areas',
        trackingName: 'focus_areas',
        screenName: 'focus areas',
        component: (
            <MultiSelectScreen
                position={17}
                sectionKey={'habits'}
                answerKey={'focus_areas'}
                title={'What areas of your drinking can we help you improve?'}
                subtitle={'Choose as many as you\'d like:'}
                choices={FOCUS_AREAS}
            />
        )
    },
    {
        key: 'drink journey',
        trackingName: 'drink journey',
        screenName: 'drink journey',
        component: (
            <DrinkJourney
                position={18}
            />
        )
    },
    {
        key: 'habits section quote',
        trackingName: 'habits section quote',
        screenName: 'habits section quote',
        component: <HabitsQuote />
    }
];
